;(function (root, _) {
  'use strict'

  /**
   * Sanitize a regular expression so that every character is either in
   * the Latin alphabet (A-Z) or an underscore.
   *
   * @param {(regexp|string)} pattern - The regular expression to sanitize.
   * @returns {string} The sanitized regular expression.
   *
   * @access private
   */
  function sanitizeRegExp(pattern) {
    var asString = _.isRegExp(pattern) ? pattern.source : pattern

    var sanitized = asString.replace(/[^a-zA-Z]/g, '_')

    return sanitized
  }

  /**
   * Humanize a given password rule.
   *
   * @param {*} data - The data for the rule.
   * @param {string} name - The name of the rule.
   * @returns {(null|Array)} The recognized, humanized rules.
   *
   * @access public
   * @todo <jordan@workwithopal.com> I18n
   */
  function humanizeRule(data, name) {
    var description
    var rules

    if (name.match(/^character_patterns/)) {
      rules = Array.isArray(data) ? data : [data]

      return rules.map(function (rule) {
        return {
          description: 'Password must have ' + window.humanizeRegExp(rule),
          sanitizedRule: name + sanitizeRegExp(rule),
        }
      })
    }

    switch (name) {
      case 'history_length':
        description =
          data <= 1
            ? null
            : 'Password must be different than your last ' + data + ' passwords'
        break
      case 'password_length':
        description = 'Password must be at least ' + data + ' characters long'
        break
      default:
        description = null
    }

    if (!description) return null

    return {
      description: description,
      sanitizedRule: name,
    }
  }
  root.humanizePasswordRule = humanizeRule
})(window, _)
